import React from 'react';
import { ErrorMessage, Field } from 'formik';
import PropTypes from 'prop-types';

import LazyLoadSelect from 'components/LazyLoadSelect';
import useApi from 'hooks/useApi';

import ENDPOINT from 'constants/endpoints';

const SendMessageFormRecipientSelect = props => {
  const {
    name,
    labelText = 'To',
    labelStyles = { fontWeight: 'bold' },
    required = true,
    placeholder = 'Start Typing',
  } = props;

  const api = useApi();

  const fetchOptions = async (query, offset) =>
    new Promise(resolve => {
      api.get(
        ENDPOINT.FORM.OPTIONS.INBOX.RECIPIENTS,
        { query, offset },
        { handleSuccess: result => resolve(result) }
      );
    });

  return (
    <Field name={name}>
      {({
        field: { name, value },
        form: { touched, errors, setFieldValue, setFieldTouched },
      }) => (
        <>
          <LazyLoadSelect
            name={name}
            value={value || null}
            isValid={(!errors[name] && !!touched[name]) || !touched[name]}
            label={labelText}
            labelStyles={labelStyles}
            required={required}
            placeholder={placeholder}
            getOption={fetchOptions}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
          />

          <ErrorMessage
            name={name}
            render={message => <div className="form__error">{message}</div>}
          />
        </>
      )}
    </Field>
  );
};

SendMessageFormRecipientSelect.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  labelStyles: PropTypes.object,
};

export default SendMessageFormRecipientSelect;
